import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import { MiSaldoCard } from './components/MiSaldoCard/MiSaldoCard';
import { IframeView } from './components/IframeView/IframeView';
import { PrestamoCard } from './components/PrestamoCard/PrestamoCard';
import { Prueba } from './components/Pruebas/Prueba';
import './App.css';


function App() {

 

  return (
    <>
      <Router>
        <Switch>
       
          <Route path='/Iframe'>
            <IframeView />
          </Route>
          <Route path='/Prestamo'>
            <PrestamoCard></PrestamoCard>
          </Route>
          <Route path='/MiSaldo'>
            <MiSaldoCard />
          </Route>
          <Route path='/'>
            <Prueba />
          </Route>
        </Switch>
      </Router>

    </>
  );
}

export default App;
